export const normalizeDownloadLinks = (links) => {
  const linksKeyMap = {
    '320kbs.mp3': 'mp3',
  };
  return Object.keys(links).reduce(
    (acc, key) => ({
      ...acc,
      [linksKeyMap[key] || key]: links[key],
    }),
    {},
  );
};
